export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'UG',
        name: 'Uighur Arabic',
        normal: "`١٢٣٤٥٦٧٨٩٠-=\\قشېرتيۇیوپ[]ڧسدفگهجكل;'زخچۋبنم,./",
        shift: { 0: '~!@#$٪^&*()_+|', 20: 'ۈ،ۆ؛{}ه', 30: 'غ', 32: '؟لالا:"ژ', 42: 'ڭ', 44: '<>?' }
    })
}
